module.exports = __webpack_public_path__ + "img/PDF.2063626a.svg";